<style>
    .app-header-content-divider>a {
        color: #fff;
        text-decoration: none;
    }
</style>
<app-loader *ngIf="loading"></app-loader>
<div class="app">
    <div class="user-info">
        <!-- {{ 'app.login' | translate }} {{ 'app.register' | translate }} {{ 'app.contact' | translate }} -->
        <app-language-selector></app-language-selector>
    </div>
    <div [@visibility]="state">
        <div class="app-header" *ngIf="state === 'hasimage'">
            <app-loading-indicator class="top"></app-loading-indicator>
            <img class="event-image" [src]="domSanitizer.bypassSecurityTrustUrl(eventImage)" />
            <div class="event-details">
                <h1 [ngStyle]="{'color': eventTheme}">{{ eventName }}</h1>
                <p>{{ eventStartDate | date: 'd MMM yyyy' : '' : dateFormat }} - {{ eventEndDate | date: 'd MMM yyyy' :
                    '' : dateFormat }} </p>
            </div>
            <img *ngIf="eventLogoType == 'Dark'" src="./assets/logo-dark.svg" class="app-logo" name="Logo" alt="Foreign Affairs logo." />
            <img *ngIf="eventLogoType == 'Light'" src="./assets/logo-light.svg" class="app-logo" name="Logo" alt="Foreign Affairs logo." />
        </div>
    </div>
    <div *ngIf="state === 'noimage'">
        <div class="app-header no-event-image">
            <img src="./assets/logo-dark.svg" class="app-logo" name="Logo" alt="Foreign Affairs logo." />
        </div>
        <div class="app-header-content-divider">
            <a routerLink="">{{ 'app.title' | translate }}</a>
            <app-loading-indicator></app-loading-indicator>
        </div>
    </div>
    <div class="app-content">
        <router-outlet></router-outlet>
    </div>
    <div class="footer">
        <div class="wrapper">
            <div class="column">
                <h2>{{ 'footer.text' | translate }}</h2>
                <ul>
                    <li><a href="/about/copyright">{{ 'footer.copyright' | translate }}</a></li>
                    <li><a href="/about/privacy">{{ 'footer.privacy' | translate }}</a></li>
                    <li><a href="/about/cookies">{{ 'footer.cookies' | translate }}</a></li>
                    <li><a href="/about/accessability">{{ 'footer.accessibility' | translate }}</a></li>
                    <li><a href="/about/archive">{{ 'footer.archive' | translate }}</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>